import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { StandardContentContainer } from '../Shared/CommonStyles';

export const PostSpecificContainer = styled(StandardContentContainer)`
	max-width: 800px; 
`;

// Styles the ReactMarkdown body: bare p/ul/ol/li emitted by
// react-markdown all need explicit styling.
export const PostContent = styled.div`
	margin-top: 32px; 

	p {
		font-size: clamp(1rem, 1.8vw, 1.1rem);
		line-height: 1.7; 
		color: #333;
		margin-bottom: 24px; 
		text-align: justify;

		@media (max-width: 768px) {
			text-align: left;
		}
	}

	ul,
	ol {
		margin-bottom: 24px;
		padding-left: 30px;
	}

	li {
		margin-bottom: 8px;
		line-height: 1.7;
	}
`;

export const StyledImage = styled.img`
	max-width: 100%;
	width: 100%; 
	height: auto; 
	border-radius: 8px; 
	margin: 16px 0 24px 0; 
`;

export const VideoContainer = styled.div`
	position: relative;
	width: 100%;
	max-width: 800px;
	margin: 16px 0 24px 0;
	aspect-ratio: 16 / 9;

	iframe {
		width: 100%;
		height: 100%;
		border: none;
		border-radius: 8px;
	}
`;

export const VideoPlayer = styled.video`
	width: 100%;
	max-width: 800px;
	height: auto;
	border-radius: 8px;
	margin: 16px 0 24px 0;
	display: block;
	background: #000;
`;

export const AdminActions = styled.div`
	margin-top: 48px;
	padding-top: 24px;
	border-top: 1px solid #eee;
	display: flex;
	gap: 16px;
	align-items: center;

	@media (max-width: 768px) {
		margin-top: 32px;
		padding-top: 16px;
		gap: 12px;
	}
`;

export const ActionButton = styled.button`
	padding: 10px 20px;
	border: none;
	border-radius: 5px;
	cursor: pointer;
	font-size: 0.95rem;
	transition: background-color 0.2s ease, transform 0.1s ease;

	&:hover {
		transform: translateY(-1px);
	}

	&:active {
		transform: translateY(0);
	}
`;

export const EditLink = styled(Link)`
	display: inline-block;
	padding: 10px 20px;
	border-radius: 5px;
	text-decoration: none;
	font-size: 0.95rem;
	background-color: var(--color-secondary-light, #ecf0f1);
	color: var(--color-secondary-dark, #2c3e50);
	transition: background-color 0.2s ease, transform 0.1s ease;

	&:hover {
		background-color: var(--color-secondary-lighter, #dde4e6);
		transform: translateY(-1px);
	}
	&:active {
		transform: translateY(0);
	}
`;

export const DeleteButton = styled(ActionButton)`
	background-color: #e74c3c;
	color: white;

	&:hover {
		background-color: #c0392b;
	}
`;
